import { formatDateLocalWithTime, formatDateLocal } from "../../lib/script";
import { modelTypesSystem } from "../../lib/systemData";
import SimpleCopyTextButton from "../common/SimpleCopyTextButton";
import TableNameLink from "../common/TableNameLink";
    
export default function HistoryRow({data, classes, isInTab}) {
    const datesMatch = formatDateLocal(data.created_at) === formatDateLocal(data.created_at_timestamp);
    const createdAt = datesMatch ? data.created_at_timestamp : data.created_at;
    
    return <tr>
        {/* if we are on tab and not on history page, remove the NG# and person name!!!  */}
        {!isInTab && <>
            <td className="table-cell-fit">
                <SimpleCopyTextButton textToCopy={data?.patient?.person_number} />
            </td>
            <td className="table-cell-no-padding table-cell-fit">
                <TableNameLink text={data?.patient?.name} case_id={data?.case_id} case_data={data}/>                        
            </td>
        </>}
        
        <td className="table-cell-fit">{!datesMatch
                        ? formatDateLocal(createdAt)
                        : formatDateLocalWithTime(createdAt)}</td>
        <td className="table-cell-fit">{data.source}</td>
        <td className="table-cell-fit">{data.user_name}</td>
        <td className="table-cell-fit">{data.model_type ? modelTypesSystem().find(item => item.value == data.model_type)?.label : ''}</td>
        <td ><div dangerouslySetInnerHTML={{__html: data.message}} className={classes.message}/></td>
    </tr>
}